import { Download, Plus } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/shared/components/ui/button'

import CreateQuoteDialog from './CreateQuoteDialog'

export default function QuoteHeader({ onExport }) {
  const [open, setOpen] = useState(false)

  return (
    <div className="rounded-2xl border bg-white p-4 shadow-sm sm:rounded-3xl sm:p-7">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold sm:text-3xl">Quotes</h1>

          <p className="mt-1 text-xs text-muted-foreground sm:mt-2 sm:text-sm">
            Generate proforma invoices and push accepted quotes to Tally.
          </p>
        </div>

        <div className="flex items-center gap-2">
          <Button
            onClick={() => setOpen(true)}
            className="rounded-full bg-[#0F172A] px-6 text-white shadow-sm hover:bg-[#1E293B]"
          >
            <Plus className="mr-2 h-4 w-4" />
            Create Quote
          </Button>

          <Button
            variant="outline"
            onClick={onExport}
            className="rounded-full px-6 shadow-sm"
          >
            <Download className="mr-2 h-4 w-4" />
            Export
          </Button>
        </div>
      </div>

      {/* Modal with lead selector */}
      <CreateQuoteDialog open={open} onOpenChange={setOpen} />
    </div>
  )
}
